
import { WorldCity } from '../types';

// Expansión adicional de Nigeria - 75 ciudades más
export const nigeriaAdditionalCities2: WorldCity[] = [
  { name: 'Kano', slug: 'kano', population: 3626068 },
  { name: 'Ibadan', slug: 'ibadan', population: 3649000 },
  { name: 'Abuja', slug: 'abuja', population: 2440000 },
  { name: 'Port Harcourt', slug: 'port-harcourt', population: 1865000 },
  { name: 'Benin City', slug: 'benin-city', population: 1495800 },
  { name: 'Maiduguri', slug: 'maiduguri', population: 1112449 },
  { name: 'Zaria', slug: 'zaria', population: 975153 },
  { name: 'Aba', slug: 'aba', population: 897560 },
  { name: 'Jos', slug: 'jos', population: 816824 },
  { name: 'Ilorin', slug: 'ilorin', population: 777667 },
  { name: 'Oyo', slug: 'oyo', population: 736072 },
  { name: 'Enugu', slug: 'enugu', population: 688862 },
  { name: 'Abeokuta', slug: 'abeokuta', population: 593100 },
  { name: 'Kaduna', slug: 'kaduna', population: 582651 },
  { name: 'Akure', slug: 'akure', population: 484798 },
  { name: 'Bauchi', slug: 'bauchi', population: 493781 },
  { name: 'Sokoto', slug: 'sokoto', population: 427760 },
  { name: 'Onitsha', slug: 'onitsha', population: 561066 },
  { name: 'Warri', slug: 'warri', population: 536023 },
  { name: 'Ebute Ikorodu', slug: 'ebute-ikorodu', population: 535619 },
  { name: 'Okene', slug: 'okene', population: 479178 },
  { name: 'Calabar', slug: 'calabar', population: 461796 },
  { name: 'Uyo', slug: 'uyo', population: 436606 },
  { name: 'Katsina', slug: 'katsina', population: 432149 },
  { name: 'Ado-Ekiti', slug: 'ado-ekiti', population: 424340 },
  { name: 'Ogbomoso', slug: 'ogbomoso', population: 441604 },
  { name: 'Umuahia', slug: 'umuahia', population: 359230 },
  { name: 'Ede', slug: 'ede', population: 355997 },
  { name: 'Damaturu', slug: 'damaturu', population: 348325 },
  { name: 'Gombe', slug: 'gombe', population: 342980 },
  { name: 'Kumo', slug: 'kumo', population: 318036 },
  { name: 'Ikire', slug: 'ikire', population: 313615 },
  { name: 'Shaki', slug: 'shaki', population: 309924 },
  { name: 'Ondo', slug: 'ondo', population: 296910 },
  { name: 'Jimeta', slug: 'jimeta', population: 248148 },
  { name: 'Gusau', slug: 'gusau', population: 226857 },
  { name: 'Minna', slug: 'minna', population: 304113 },
  { name: 'Effon-Alaiye', slug: 'effon-alaiye', population: 263432 },
  { name: 'Ikot Ekpene', slug: 'ikot-ekpene', population: 261457 },
  { name: 'Gboko', slug: 'gboko', population: 261934 },
  { name: 'Ejigbo', slug: 'ejigbo', population: 258264 },
  { name: 'Ugep', slug: 'ugep', population: 253148 },
  { name: 'Igboho', slug: 'igboho', population: 246163 },
  { name: 'Gashua', slug: 'gashua', population: 245149 },
  { name: 'Hadejia', slug: 'hadejia', population: 237829 },
  { name: 'Jalingo', slug: 'jalingo', population: 237000 },
  { name: 'Keffi', slug: 'keffi', population: 232664 },
  { name: 'Ikeja', slug: 'ikeja', population: 313196 },
  { name: 'Agege', slug: 'agege', population: 500000 },
  { name: 'Mushin', slug: 'mushin', population: 633009 },
  { name: 'Oshodi', slug: 'oshodi', population: 621509 },
  { name: 'Alaba', slug: 'alaba', population: 318166 },
  { name: 'Shomolu', slug: 'shomolu', population: 402673 },
  { name: 'Kosofe', slug: 'kosofe', population: 682772 },
  { name: 'Ifako-Ijaiye', slug: 'ifako-ijaiye', population: 427878 },
  { name: 'Surulere', slug: 'surulere', population: 503975 },
  { name: 'Apapa', slug: 'apapa', population: 217362 },
  { name: 'Lagos Mainland', slug: 'lagos-mainland', population: 317720 },
  { name: 'Yaba', slug: 'yaba', population: 181300 },
  { name: 'Lagos Island', slug: 'lagos-island', population: 209437 },
  { name: 'Badagry', slug: 'badagry', population: 241093 },
  { name: 'Epe', slug: 'epe', population: 181409 },
  { name: 'Amuwo-Odofin', slug: 'amuwo-odofin', population: 318166 },
  { name: 'Eti-Osa', slug: 'eti-osa', population: 287785 },
  { name: 'Ibeju-Lekki', slug: 'ibeju-lekki', population: 117481 },
  { name: 'Gombe', slug: 'gombe-alt', population: 250258 },
  { name: 'Birnin Kebbi', slug: 'birnin-kebbi', population: 108164 },
  { name: 'Yenagoa', slug: 'yenagoa', population: 266008 },
  { name: 'Asaba', slug: 'asaba', population: 149603 },
  { name: 'Sapele', slug: 'sapele', population: 174273 },
  { name: 'Ugbokolo', slug: 'ugbokolo', population: 99182 },
  { name: 'Makurdi', slug: 'makurdi', population: 300000 },
  { name: 'Abakaliki', slug: 'abakaliki', population: 134102 },
  { name: 'Awka', slug: 'awka', population: 301657 },
  { name: 'Nsukka', slug: 'nsukka', population: 309633 },
  { name: 'Owerri', slug: 'owerri', population: 125337 },
  { name: 'Orlu', slug: 'orlu', population: 420600 },
  { name: 'Nnewi', slug: 'nnewi', population: 391227 }
];

export const nigeriaExpanded2 = {
  code: 'NG',
  name: 'Nigeria',
  slug: 'nigeria',
  population: 218541212,
  topCities: [
    { name: 'Lagos', slug: 'lagos', population: 14368332 },
    ...nigeriaAdditionalCities2
  ]
};
